export default {
  body: {
    margin: 10,
  },
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
};



// WEBPACK FOOTER //
// ./src/components/Addresses/AddressDialog/styles.js